// extracted by mini-css-extract-plugin
export default {"deleteIcon":"delete-app-confirm_deleteIcon__Mro5U"};